import { Space } from 'antd';
import styled from 'styled-components';
import { Avatar } from 'components/atoms/avatar';
import { ProductiveHeading06, SingleLineEllipsis } from 'components/styles';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const TitleContainer = styled.span`
  ${SingleLineEllipsis};
  flex-grow: 1;
  display: flex;
  align-items: center;
`;

export const CompanyLogo = styled(Avatar).attrs({ shape: 'square' })`
  width: var(--spacing-08);
  height: var(--spacing-08);
  margin-right: var(--spacing-06);
`;

export const Title = styled.h6`
  ${ProductiveHeading06};
  ${SingleLineEllipsis};
  margin-top: var(--spacing-02);
  width: 50%;
`;

export const RightMenuContainer = styled(Space).attrs({
  align: 'center',
})``;
